import React from 'react';
import { Row, Col, Grid } from 'rsuite';

import Navigation from './Navigation';
import SideNav from './SideNav';

const Layout = (props)=>{
	return (
		
		 <Grid fluid>
            <Row style={{display:'flex', margin:0}}>
                <Col sm={1} smHidden xsHidden className="s-background-sidebar app-sidebar-rail" style={{padding:0, width:56, minWidth:56, maxWidth:56, flex:'0 0 56px'}}>
                    <SideNav {...props} />
                </Col>
                <Col sm={24} md={23} style={{padding:0, width:'auto', flex:'1 1 0%'}}>
                    <Grid fluid style={{padding:0}}>
                        <Row style={{margin:0}}>
                            <Col xs={24} style={{padding:0}}>
                                <Navigation {...props} />
                            </Col>
                        </Row>

                        <Row style={{margin:0}}>
                            <Col xs={24} className="app-main-content">
								{props.children}
                            </Col>
                        </Row>
                    </Grid>
                </Col>
            </Row>
        </Grid>
		
	)
}

export default Layout;